import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function SummaryCards({ summaryData, onClick, setSelectedId, selectedId }) {
    const summary = [
        {
            amount: summaryData?.totalMovedOut || 0,
            label: `Total Move-Outs`,
            color: "text-black",
            icon: <FaUser size={20} className="text-blue-400" />,
            filter: 'E',
        },
        {
            amount: summaryData?.cancelledBooking || 0,
            //label: `${currentMonthName} Months`,
            label: 'Cancelled Bookings',
            color: "text-black",
            icon: <FaUser size={20} className="teal-yellow-400" />,
            filter: 'CB',
        },
        {
            amount: summaryData?.defaulters || 0,
            subTitle: (summaryData?.totalDefaultedDues || 0),
            label: `Defaulters`,
            color: "text-black",
            icon: <FaUser size={20} className="text-red-400" />,
            filter: 'ED',
        },
        {
            amount: summaryData?.workingPending || 0,
            label: `FnF Pending`,
            color: "text-black",
            icon: <FaUser size={20} className="text-red-400" />,
            filter: 'WP',
        },
        {
            amount: "₹" + (summaryData?.totalRefundAmount || 0),
            label: `Tentative Refund`,
            color: "text-black",
            icon: <FaUser size={20} className="text-red-400" />,
            // filter: 'WP',
        },
    ];
    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {summary.map((item, index) => {
                    const isClickable = !!item.filter;

                    return (
                        <Card
                            key={item.label}
                            $selected={selectedId === index}
                            $clickable={isClickable}
                            onClick={() => {
                                if (!isClickable) return;
                                const isSelected = selectedId === index;
                                if (isSelected) {
                                    setSelectedId(null);
                                    onClick("E");
                                }
                                else {
                                    setSelectedId(index);
                                    onClick(item.filter);
                                }
                            }}
                        >
                            <ValueRow>
                                <div className='flex flex-row'>
                                    <Value color={item.color}>{item.amount}</Value>
                                    {item.subTitle &&
                                        <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + item.subTitle + ")"}</span>
                                    }
                                </div>

                            </ValueRow>

                            <Label>
                                {item.label}
                                {isClickable &&
                                    <ArrowWrap className="arrow">
                                        <Chevron />
                                    </ArrowWrap>
                                }
                            </Label>
                        </Card>
                    )
                })}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;
const ValueRow = tw.div`
  flex items-baseline gap-1
`;
const Value = tw.div`
  text-xl font-semibold text-gray-900
`;
const Label = tw.div`
  flex mt-2 text-sm text-gray-500 items-center justify-between
`;
const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;
const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;
export default SummaryCards;

